import { ReactComponent as GooglePay } from 'assets/icons/GooglePay.svg';
import Icon from 'components/lib/Icon';
import './Icon.scss';

export const GooglePayIcon = () => (
  <Icon id="GooglePay-Icon" icon={GooglePay} viewBox="540 160 5 420" />
);
